module.exports = __webpack_public_path__ + "img/colab-ascofame.8e653d0e.png";